// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__uEiiV","content":"NotFound_content__1SIn9"};